/**
* 机构-销课记录详情
*/
<template>
    <div>
        <van-nav-bar placeholder title="销课记录详情" left-text="" left-arrow @click-left="onClickLeft()">
            <template #right>
            </template>
        </van-nav-bar>
        <van-pull-refresh v-model="loading" @refresh="refresh()" style="min-height: 100vh">
                <div class="yj-box">
                    <div class="box-title">
                        <h2>销课信息</h2>
                        <!--  <img src="~@/assets/xl.png">-->
                    </div>
                    <div class="yj-con">
                        <div class="con-list"><span>机构名称：</span><p>{{ curriculumInfo.institutionName }}</p></div>
                        <div class="con-list"><span>课程名称：</span><p>{{ curriculumInfo.name }}</p></div>
                        <div class="con-list"><span>任课教师：</span><p>{{ curriculumInfo.teacherName }}</p></div>
                        <div class="con-list"><span>实际上课时间：</span><p>{{ moment(record.signTime).format("YYYY-MM-DD HH:mm") }}</p></div>
                    </div>
                </div>
                <div  class="yj-box">
                    <div  class="box-title">
                        <h2>学员信息</h2>
                        <!--<img src="~@/assets/xl.png">-->
                    </div>
                    <div class="yj-con"  v-for="item in applyInfoList" :key="item.id">
                        <div class="xk-list">
                          <div class="xk-box-top"><b>{{ item.studentName }}</b> <b>{{ item.phone }}</b></div>
                          <div class="xk-box-bottom">
                            <span v-show="item.signHour">{{ item.signHour }}课时</span>
                            <i v-show="item.classHour">{{ filterLabelName(signStatusOption, item.status) }}</i>
                          </div>

                        </div>
                    </div>
                </div>
        </van-pull-refresh>
    </div>
</template>

<script>
    import {signDetailInfo} from '@/api/course/institutionCourse'
    import {filterLabelName, getDictByType} from '@/api/common'
    import moment from 'moment'

    export default {
        name: 'SignDetailInfo',
        components: {
        },
        data () {
            return {
                filterLabelName,
                moment,
                signId: '',
                signDetailId: '',
                loading: false,
                show: false,
                submitLoading: false,
                id: '',
                curriculumInfo: {},
                record: {},
                signStatusOption: [],
                applyInfoList: []
            }
        },
        computed: {
        },
        created () {
            this.getDict();
            this.signId = this.$route.query.signId;
            this.signDetailId = this.$route.query.signDetailId;
            this.refresh()
        },
        mounted () {
        },
        methods: {
            refresh() {
                this.getDetail()
            },
            getDetail() {
                signDetailInfo({ signId: this.signId, signDetailId: this.signDetailId }).then(res => {
                    if (res.code === 10000) {
                        this.record = res.result || {};
                        this.applyInfoList = this.record.detailList || [];
                        this.curriculumInfo = this.record.curriculumInfo || {}
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.loading = false
                    }, 100)
                })
            },
            onClickLeft() {
                this.$router.go(-1)
            },
            // 数据字典
            getDict() {
                // 查询字典，销课状态
                getDictByType('sign_status').then(res => {
                    if (res.code === 10000) {
                        this.signStatusOption = res.result.map(item => {
                            return {label: item.dictKey, value: item.dictValue}
                        })
                    }
                });
            },
        }
    }


</script>

<style scoped>
    .yj-box{
        display: flex;
        margin: 0 10px;
        flex-direction: column;
    }
    .box-title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        height:16px;
        margin-top: 23px;
        margin-bottom: 17px;
    }
    .box-title h2{
        display: flex;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #000000;
    }
    .box-title img{
        width: 16px;
        height: 9px;
    }
    .yj-con{
        background: #F4F5F7;
        border-radius:12px;
        display: flex;
        padding: 17px;
        flex-direction: column;
      margin-bottom: 10px;
    }
    .con-list{
        display: flex;
        margin-bottom: 15px;
    }

    .con-list:last-child{
        margin-bottom: 0;
    }
    .con-list span{
        display: flex;
        font-size:14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #777777;
        justify-content: flex-end;
        padding-right: 5px;
    }
    .con-list p{
        display: flex;
        flex: 1;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }
    /deep/.van-uploader__preview-image{
        height: 15vw;
        width:73px;
    }
    .box-style{
        padding-bottom: 20px;
    }
    .xk-list{
      display: flex;
      flex-direction: column;
    }
    .xk-box{
      margin-bottom: 10px;
    }
    .xk-box-top{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom:15px;
    }
    .xk-box-bottom{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .xk-box-bottom span{
      font-size:14px;
    }
    .xk-box-top b{
      font-size:14px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #000000;
    }
    .xk-box-bottom i{
      display: flex;
      align-items: center;
      justify-content: center;
      font-size:12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      padding:4px 6px;
      border-radius:12px;
      background: #FF9900;
    }
</style>
